export enum CreditOperation {
  CREDITING = 'crediting',
  UNDO_CREDITING = 'undoCrediting'
}

export enum NominalHoursOperation {
  CREATE = 'create',
  UPDATE = 'update'
}
